import React from "react";
import PageTitle from "../PageTitle";
import { doRequest } from "../../helper";
import $ from "jquery";
import { CSVLink } from "react-csv";

const headers = [
  { label: "State Name", key: "state" },
  { label: "Post Count", key: "postCount" },
];
const headers1 = [
  { label: "State Name", key: "state" },
  { label: "City Name", key: "constituency" },
  { label: "Post Count", key: "postCount" },
];
const headers2 = [
  { label: "Scheme", key: "benscheme" },
  { label: "Post Count", key: "postCount" },
];
const headers3 = [
  { label: "Leader Name", key: "NAME" },
  // { label: "State Name", key: "state" },
  { label: "Mobile", key: "mobile" },
  { label: "Post Count", key: "postCount" },
];
const headers4 = [
  { label: "State Name", key: "state" },
  { label: "District Name", key: "kar_district" },
  { label: "Post Count", key: "postCount" },
];

export default class MahilaDateCount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      stateitem: [],
      response: null,
      status: "Active",
    };
    this.stateList = this.stateList.bind(this);
    this.constList = this.constList.bind(this);
    this.schemeList = this.schemeList.bind(this);
    this.leaderList = this.leaderList.bind(this);
  }
  componentDidMount() {
    this.stateList();
  }
  componentWillReceiveProps(nextProps) {}

  stateList = (loadmore) => {
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        action: "state",
      }),
    };
    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          ref.setState(
            {
              response: result,
              items: result.response,
              post_count: postCount,
              type: "state",
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };
  constList = (loadmore) => {
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        action: "constituency",
      }),
    };
    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          ref.setState(
            {
              response: result,
              items: result.response,
              post_count: postCount,
              type: "constituency",
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };
  distList = (loadmore) => {
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        action: "district",
      }),
    };
    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          ref.setState(
            {
              response: result,
              items: result.response,
              post_count: postCount,
              type: "district",
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };
  schemeList = (loadmore) => {
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        action: "scheme",
      }),
    };
    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          ref.setState(
            {
              response: result,
              items: result.response,
              post_count: postCount,
              type: "scheme",
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };
  leaderList = (loadmore) => {
    var settings = {
      url: "https://mmapi.narendramodi.in/v1/mahila-rds/getData",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        action: "leader",
      }),
    };
    let ref = this;
    $.ajax(settings).done(function (result) {
      try {
        if (result.resultFlag && result.resultFlag == "1") {
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...result.response]
            : result.response;
          let postCount = 0;
          loadMoreItems.map((item) => {
            postCount += item["postCount"];
          });
          ref.setState(
            {
              response: result,
              items: result.response,
              post_count: postCount,
              type: "leader",
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) {}
    });
  };

  render() {
    var bread = "Mahila Morcha / GridView";
    var items = this.state.items;
    var type = this.state.type;
    return (
      <div>
        <PageTitle
          title="#Mahila Morcha"
          bread={bread}
          Count={this.state.post_count}
        />
        <div className="wrapper wrapper-content">
          <div>
            <h3>PostCount Filter by : </h3>
            <h3
              style={{
                margin: "-30px 18px 15px 0px",
                color: "#139d13",
                right: "0px",
                position: "absolute",
              }}
            >
              Count : {this.state.post_count && this.state.post_count}
            </h3>
          </div>
          <div className="form-inline form_right" style={{ top: "0px" }}>
            <div className="row row_date_div">
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn btn-info"
                onClick={() => {
                  this.stateList();
                }}
              >
                State
              </button>
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn btn-info"
                onClick={() => {
                  this.constList();
                }}
              >
                Constituency
              </button>
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn btn-info"
                onClick={() => {
                  this.distList();
                }}
              >
                District
              </button>
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn btn-info"
                onClick={() => {
                  this.schemeList();
                }}
              >
                Scheme
              </button>
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn btn-info"
                onClick={() => {
                  this.leaderList();
                }}
              >
                Leader
              </button>
              <button
                style={{
                  padding: "0px 10px",
                  "border-radius": "20px",
                  "margin-left": "10px",
                }}
                className="btn-success"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Clear filters
              </button>
              {type === "state" && (
                <CSVLink
                  style={{
                    margin: "0px 0px -6px 30px",
                    right: "0px",
                    position: "absolute",
                  }}
                  data={items}
                  headers={headers}
                  filename="Mahila_morcha_Statecount.csv"
                >
                  <img
                    style={{ width: "30px" }}
                    alt="image"
                    src="/img/filetype-csv.svg"
                  />
                </CSVLink>
              )}
              {type === "constituency" && (
                <CSVLink
                  style={{
                    margin: "0px 0px -6px 30px",
                    right: "0px",
                    position: "absolute",
                  }}
                  data={items}
                  headers={headers1}
                  filename="Mahila_morcha_Constituencycount.csv"
                >
                  <img
                    style={{ width: "30px" }}
                    alt="image"
                    src="/img/filetype-csv.svg"
                  />
                </CSVLink>
              )}
              {type === "district" && (
                <CSVLink
                  style={{
                    margin: "0px 0px -6px 30px",
                    right: "0px",
                    position: "absolute",
                  }}
                  data={items}
                  headers={headers4}
                  filename="Mahila_morcha_Districtcount.csv"
                >
                  <img
                    style={{ width: "30px" }}
                    alt="image"
                    src="/img/filetype-csv.svg"
                  />
                </CSVLink>
              )}
              {type === "scheme" && (
                <CSVLink
                  style={{
                    margin: "0px 0px -6px 30px",
                    right: "0px",
                    position: "absolute",
                  }}
                  data={items}
                  headers={headers2}
                  filename="Mahila_morcha_Schemecount.csv"
                >
                  <img
                    style={{ width: "30px" }}
                    alt="image"
                    src="/img/filetype-csv.svg"
                  />
                </CSVLink>
              )}
              {type === "leader" && (
                <CSVLink
                  style={{
                    margin: "0px 0px -6px 30px",
                    right: "0px",
                    position: "absolute",
                  }}
                  data={items}
                  headers={headers3}
                  filename="Mahila_morcha_Leadercount.csv"
                >
                  <img
                    style={{ width: "30px" }}
                    alt="image"
                    src="/img/filetype-csv.svg"
                  />
                </CSVLink>
              )}
            </div>
          </div>
        </div>
        <hr style={{ margin: "0px", "border-top": "1px solid black" }} />
        <div className="wrapper wrapper-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                {type === "state" && (
                  <table className="table mt-5">
                    <thead className="thead-dark">
                      <tr>
                        <th>State</th>
                        <th>Post Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(items) &&
                        items.map((value, index) => {
                          return (
                            <tr>
                              <td>{value.state ? value.state : "null"}</td>
                              <td>{value.postCount ? value.postCount : "0"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
                {type === "constituency" && (
                  <table className="table mt-5">
                    <thead className="thead-dark">
                      <tr>
                        <th>State</th>
                        <th>Constituency</th>
                        <th>Post Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(items) &&
                        items.map((value, index) => {
                          return (
                            <tr>
                              <td>{value.state ? value.state : "null"}</td>
                              <td>
                                {value.constituency
                                  ? value.constituency
                                  : "null"}
                              </td>
                              <td>{value.postCount ? value.postCount : "0"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
                {type === "district" && (
                  <table className="table mt-5">
                    <thead className="thead-dark">
                      <tr>
                        <th>State</th>
                        <th>District</th>
                        <th>Post Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(items) &&
                        items.map((value, index) => {
                          return (
                            <tr>
                              <td>{value.state ? value.state : "null"}</td>
                              <td>
                                {value.kar_district
                                  ? value.kar_district
                                  : "null"}
                              </td>
                              <td>{value.postCount ? value.postCount : "0"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
                {type === "scheme" && (
                  <table className="table mt-5">
                    <thead className="thead-dark">
                      <tr>
                        <th>Scheme</th>
                        <th>Post Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(items) &&
                        items.map((value, index) => {
                          return (
                            <tr>
                              <td>
                                {value.benscheme ? value.benscheme : "null"}
                              </td>
                              <td>{value.postCount ? value.postCount : "0"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
                {type === "leader" && (
                  <table className="table mt-5">
                    <thead className="thead-dark">
                      <tr>
                        <th>Leader</th>
                        {/* <th>State</th> */}
                        <th>Mobile</th>
                        <th>Post Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(items) &&
                        items.map((value, index) => {
                          return (
                            <tr>
                              <td>{value.NAME ? value.NAME : "null"}</td>
                              {/* <td>{value.state ? value.state : "null"}</td> */}
                              <td>{value.mobile ? value.mobile : "0"}</td>
                              <td>{value.postCount ? value.postCount : "0"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/MahilaMorcha/MahilaDateCount.jsx